import React, { useContext } from "react";
import { IntlContext } from "context";
import { Link } from "react-router-dom";

export type HeaderProps = {};

const HeaderStats: React.FC = () => {
    const intl = useContext(IntlContext);
    return (
        <div className="home-oqali">
            <header className={`header-home`}></header>

            {/* SEARCH BAR */}
            <div className="block-searchbar">
                <div className="container"></div>
            </div>

            <React.Fragment>
                {/* FAQ */}
                <div className="page-content">
                    <div className="container">
                        <br />
                        <Link className="cta cta--link button-back" to="/">
                            <i className="icon icon-arrow-left"></i>
                            {intl.formatMessage("produit.link.search")}
                        </Link>
                        <div className="information__title" style={{ textAlign: "center" }}>
                            {intl.formatMessage("stats.title")}
                        </div>
                        <div className="information-cta">
                            <div className="information-cta__group">
                                <p className="information__text">
                                    {intl.formatMessage("faq.content.content_start_explain")}
                                    <a
                                        href={`${process.env.REACT_APP_WP_URL}/publications-oqali/etudes-par-categories-d-aliments/`}
                                        className="cta--link "
                                        title={intl.formatMessage("faq.content.content_start_explain.link")}
                                    >
                                        {intl.formatMessage("faq.content.content_start_explain.link")}
                                    </a>
                                    {intl.formatMessage("faq.content.content_next_explain")}
                                </p>
                                <p className="information__text">
                                    {intl.formatMessage("faq.content.content_second_explain")}
                                </p>
                                <ul>
                                    <li>{intl.formatMessage("faq.content.puce_a")}</li>
                                    <li>
                                        {intl.formatMessage("faq.content.puce_b")}
                                        <ul>
                                            <li>{intl.formatMessage("faq.content.puce_b1")}</li>
                                            <li>{intl.formatMessage("faq.content.puce_b2")}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                            <div className="information-cta__group information-cta__group--cta">
                                <a
                                    href={`${process.env.REACT_APP_WP_URL}/donnees-publiques/faq/`}
                                    className="cta cta--secondary"
                                    title={intl.formatMessage("faq.action.link")}
                                >
                                    {intl.formatMessage("faq.action.link")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        </div>
    );
};

export default HeaderStats;
